import { render, staticRenderFns } from "./SoParticles.vue?vue&type=template&id=236f30e8"
import script from "./SoParticles.vue?vue&type=script&lang=js"
export * from "./SoParticles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports